export const phoneNumberInputStyles = {
  padding: "0px 16px",
  width: "100%",
  height: "var(--input-height)",
  border: "2px solid",
  borderColor: "var(--chakra-colors-transparent) !important",
  background: "var(--chakra-colors-gray-100) !important",
  borderRadius: "var(--input-border-radius)",
};
